<template>
  <div class="page" id="duty-of-notice">
    <div class="container">
      <div class="step" v-if="step > 0 && step < 19">
        <div class="status-bar">
          <div class="outer">
            <div class="inner" ref="step" :class="`inner-${step}`">
              <div class="text" ref="step-text">{{ step }}/18</div>
            </div>
          </div>
        </div>
      </div>

      <element-processor
        @submit="submit"
        @updateCurrentStep="updateCurrentStep"
        :data="processorData"
      >
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list intro">
            <li><h3>알릴의무는 본인이 직접, 사실대로 작성해주세요</h3></li>
            <li>
              <table>
                <tbody>
                  <tr>
                    <td>종피보험자</td>
                    <td>{{ processorData.steps[0].formData.name }}</td>
                  </tr>
                  <tr>
                    <td>관계</td>
                    <td>{{ processorData.steps[0].formData.relation }}</td>
                  </tr>
                  <tr>
                    <td>생년월일</td>
                    <td>{{ processorData.steps[0].formData.birth }}</td>
                  </tr>
                  <tr>
                    <td>등록일시</td>
                    <td>{{ processorData.steps[0].formData.createdAt }}</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              <h4>※ 알릴의무 작성안내</h4>
              <p>■ 피보험자(보험대상자)에 관한 다음 사항은 회사가 보험계약의 청약을 심사하고 인수하는데 필요한 자료이므로 보험계약자 및 피보험자는 다음 질문들에 대해 사실대로 알려야 하며 직접 작성하시기 바랍니다.</p>
              <p>■ 다음 사항을 보험설계사 등에게 구두로 알린 경우에는 보험회사에 알리지 않은 것으로 간주되므로 청약서에 서면으로 알려주시기 바랍니다.</p>
              <p>■ 만약 다음 질문들에 대하여 사실대로 알리지 않거나 사실과 다르게 알린 경우에는 보험가입이 거절될 수 있으며, 특히 내용이 <b>「중요한 사항」</b>에 해당하는 경우 회사는 보험약관에 따라 이 보험계약을 일방적으로 해지할 수 있고, 이미 보험사고가 발생하였더라도 보험금 지급을 거절하는 등 보장이 제한될 수 있습니다.</p>
              <p>■ 반면, 보험설계사 등이 보험계약자 또는 피보험자에게 고지할 기회를 주지 않았거나 사실대로 고지하는 것을 방해하는 등의 경우에는 보험계약을 해지하거나 보장을 제한할 수 없습니다.</p>
            </li>
            <li class="annotation">
              <p>※ <b>『중요한 사항』</b>이란 회사가 그 사실을 알았더라면 보험계약의 청약을 거절하거나 보험가입금액 한도 제한, 일부 보장 제외, 보험금 삭감, 보험료 할증과 같이 조건부로 인수하는 등 계약인수에 영향을 미치는 사항을 말합니다.</p>
              <p>※ 부활(효력회복)시에는 계약전 알릴의무 대상기간을 『최초 계약해지일(또는 직전 부활(효력회복)일) 이후로부터 부활(효력회복)을 청약한 날까지 의 기간』과 『계약전 알릴의무 대상기간(아래 질문의 최근 3개월,1년,5년)』중 짧은 기간으로 합니다.</p>
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step
          v-for="index in (1, 19)"
          :data="processorData.steps[index]"
          :key="index"
        >
          <component
            :is="processorData.steps[index].component"
            :formData="processorData.steps[index].formData"
            @update="(data) => update(data, index)"
          />
        </element-processor-step>
      </element-processor>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ButtonBottom from '@/components/Elements/ButtonBottom';

export default {
  name: 'DutyOfNotice',
  components: { ButtonBottom },
  data() {
    return {
      step: 0,
      title: '알릴의무',
      processorData: {
        title: '알릴의무',
        steps: [
          {
            title: '알릴의무',
            formData: {
              name: '홍길동',
              relation: '배우자',
              birth: '1990.01.01',
              createdAt: moment().format('YYYY.MM.DD HH:mm:ss')
            }
          },
          {
            title: '알릴의무 - 직업',
            component: () => import('@/components/Includes/DutyOfNotice/Job'),
            formData: {
              주업무: {
                label: "주업무",
                value: "사무직",
                error: "",
                placeholder: "주업무",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              근무처: {
                label: "근무처",
                value: "테스트",
                error: "",
                placeholder: "근무처(회사명)",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              근무지역: {
                label: "근무지역",
                value: "서울",
                error: "",
                placeholder: "근무지역",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              하시는일: {
                label: "하시는 일",
                value: "사무직입니다",
                error: "",
                placeholder: "구체적으로 적어주세요.",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: '알릴의무 - 최근 3개월 검사',
            component: () => import('@/components/Includes/DutyOfNotice/Examination'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 복용중인 약',
            component: () => import('@/components/Includes/DutyOfNotice/Medication'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 재검사',
            component: () => import('@/components/Includes/DutyOfNotice/Reexamine'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 의료행위',
            component: () => import('@/components/Includes/DutyOfNotice/Treatment'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 11대 질병',
            component: () => import('@/components/Includes/DutyOfNotice/Disease'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 임신 여부',
            component: () => import('@/components/Includes/DutyOfNotice/Pregnant'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              임신: {
                value: {
                  개월: '',
                  주: '',
                  태아: ''
                }
              }
            }
          },
          {
            title: '알릴의무 - 태아',
            component: () => import('@/components/Includes/DutyOfNotice/Fetus'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: '알릴의무 - 치아보험 특약',
            component: () => import('@/components/Includes/DutyOfNotice/Teeth'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: '알릴의무 - 운전 여부',
            component: () => import('@/components/Includes/DutyOfNotice/Drive'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              detail: [],
            }
          },
          {
            title: '알릴의무 - 자격증 여부',
            component: () => import('@/components/Includes/DutyOfNotice/Certificate'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              빈도: {
                value: {
                  주기: '',
                  횟수: ''
                }
              },
              자격증명칭: { value: '' }
            }
          },
          {
            title: '알릴의무 - 부업',
            component: () => import('@/components/Includes/DutyOfNotice/SideJob'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              업무명: { value: '' }
            }
          },
          {
            title: '알릴의무 - 출국',
            component: () => import('@/components/Includes/DutyOfNotice/Departure'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              지역: { value: '' },
              목적: { value: '' },
              기간: {
                value: {
                  시작: '',
                  끝: ''
                }
              }
            }
          },
          {
            title: '알릴의무 - 음주 여부',
            component: () => import('@/components/Includes/DutyOfNotice/Drunk'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              병수: { value: '' },
              횟수: { value: '' },
            }
          },
          {
            title: '알릴의무 - 흡연 여부',
            component: () => import('@/components/Includes/DutyOfNotice/Smoking'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              개피: { value: '' },
              연수: { value: '' },
            }
          },
          {
            title: '알릴의무 - 공제계약',
            component: () => import('@/components/Includes/DutyOfNotice/DeductionContract'),
            formData: {
              answer: {
                value: "아니오",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니오", label: "아니오" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              회사명: { value: '' },
              건수: { value: '' },
              보험료: { value: '' },
            }
          },
          {
            title: '알릴의무 - 키, 몸무게',
            component: () => import('@/components/Includes/DutyOfNotice/Info'),
            formData: {
              키: {
                label: "키",
                value: "180",
                error: "",
                placeholder: "예: 180",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              몸무게: {
                label: "몸무게",
                placeholder: '예: 72',
                value: "72",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
              },
            }
          },
          {
            title: '알릴의무 - 평균 월소득',
            component: () => import('@/components/Includes/DutyOfNotice/Salary'),
            formData: {
              월소득: {
                label: "평균 월소득",
                placeholder: '예: 180',
                value: "180",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
              }
            }
          },
          {
            title: '알릴의무가 등록되었습니다.',
            component: () => import('@/components/Includes/DutyOfNotice/Complete'),
          }
        ]
      },
      customer_id: '',
    }
  },
  mounted() {
    const { profile } = this.$store.state.customer;

    if (profile) {
      this.customer_id = profile._id;
    }
  },
  methods: {
    update(data, index) {
      if (data.type === 'detail') {
        this.processorData.steps[index].formData[data.type] = data.value;
        return;
      }

      this.processorData.steps[index].formData[data.type].value = data.value;
    },
    submit(data) {
      let obj = { notice_items: [] };

      Object
        .keys(data)
        .filter(key => {
          return key.indexOf('알릴의무 - ') !== -1
        })
        .map(key => {
          let { step_datas } = data[key];

          if (key === '알릴의무 - 직업') {
            Object.keys(step_datas).map(key2 => {
              obj[key2] = step_datas[key2].value;
            });

            return;
          }

          if (step_datas.answer) {
            step_datas.answer = {
              value: (step_datas.answer.value === '예' || step_datas.answer.value === 'yes')
            } || { value: false };
          }

          if (step_datas.detail) {
            const index = this.processorData.steps.findIndex(step => step.title === key);
            step_datas.detail = this.processorData.steps[index].formData.detail;
          }
          let item = {};

          Object.keys(step_datas).map(key2 => {
            if (key2 === 'detail') {
              item.detail = step_datas.detail;
              return;
            }

            item[key2] = step_datas[key2].value;
          })

          obj.notice_items.push(item);
        });
        
      this.axios.post('https://dev-api2.insunetfc.com/v1/crm/customer.notice/create', {
        customer_id: this.customer_id,
        customer_notice_type: '생명',
        regist_date: moment(data.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        extra: JSON.stringify(obj)
      })
    },
    updateCurrentStep(step) {
      this.step = step;
    }
  }
}
</script>
<style lang="scss">
  #duty-of-notice {
    .status-bar {
      padding-right: 0;
      margin-left: 0;
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      box-sizing: border-box;

      .outer {
        background-color: #ebeef5;
        overflow: hidden;
        position: relative;
        vertical-align: middle;
        height: 26px;

        .inner {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          background-color: #174ab5;
          text-align: center;
          line-height: 1;
          white-space: nowrap;
          transition: width .6s ease;

          &.inner-1 {
            width: 12%;
          }
          &.inner-2 {
            width: 18%;
          }
          &.inner-3 {
            width: 25%;
          }
          &.inner-4 {
            width: 30%;
          }
          &.inner-5 {
            width: 35%;
          }
          &.inner-6 {
            width: 40%;
          }
          &.inner-7 {
            width: 45%;
          }
          &.inner-8 {
            width: 50%;
          }
          &.inner-9 {
            width: 55%;
          }
          &.inner-10 {
            width: 60%;
          }
          &.inner-11 {
            width: 65%;
          }
          &.inner-12 {
            width: 70%;
          }
          &.inner-13 {
            width: 75%;
          }
          &.inner-14 {
            width: 80%;
          }
          &.inner-15 {
            width: 85%;
          }
          &.inner-16 {
            width: 90%;
          }
          &.inner-17 {
            width: 95%;
          }
          &.inner-18 {
            width: 100%;
          }
          &::after {
            display: inline-block;
            content: '';
            height: 100%;
            vertical-align: middle;
          }

          .text {
            display: inline-block;
            vertical-align: middle;
            color: #fff;
            font-size: 12px;
            margin: 0 5px;
          }
        }
      }
    }
  }
</style>